import { Repository } from './Repository'

export enum UserRoleNames {
  Admin = 'ADMIN',
  EngineeringAdmin = 'ENGINEERING ADMIN',
  Architect = 'ARCHITECT',
  LeadingArchitect = 'LEADING ARCHITECT',
  Viewer = 'VIEWER',
  LeadingStructuralEngineer = 'LEADING STRUCTURAL ENGINEER',
  StructuralEngineer = 'STRUCTURAL ENGINEER',
  LeadingElectricalEngineer = 'LEADING ELECTRICAL ENGINEER',
  ElectricalEngineer = 'ELECTRICAL ENGINEER',
}

export const architectureRoles = [
  UserRoleNames.Admin,
  UserRoleNames.LeadingArchitect,
  UserRoleNames.Architect,
]

export const engineeringRoles = [
  UserRoleNames.EngineeringAdmin,
  UserRoleNames.LeadingStructuralEngineer,
  UserRoleNames.LeadingElectricalEngineer,
  UserRoleNames.StructuralEngineer,
  UserRoleNames.ElectricalEngineer,
]

export interface UserRole extends Repository {
  name: UserRoleNames
  AccessPolicy: AccessPolicy[]
}

export enum AttributeResourceNames {
  Roles = 'roles',
  Users = 'users',
  Clients = 'clients',
  Projects = 'projects',
  Files = 'files',
  Tasks = 'tasks',
  Process = 'process',
  Payment = 'payment',
  Comments = 'comments',
  Validation = 'validation',
  TakeOff = 'takeOff',
  Permit = 'permit',
  Architecture = 'architecture',
  StructuralEngineering = 'structural engineering',
  ElectricalEngineering = 'electrical engineering',

  // Used only on UI side
  MainPage = 'main page',
}

export enum AttributeActionNames {
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
  Release = 'release',
  FindAll = 'findAll',
  Assign = 'assign',
  Approve = 'approve',
  Manage = 'manage',
}

export interface AccessAttribute extends Repository {
  resource: AttributeResourceNames
  action: AttributeActionNames
}

export interface AccessPolicy extends Repository {
  role_id: number
  attribute_id: number
  attribute: AccessAttribute
  allowed: boolean
}
